import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';

import ReportHostTasksProvider, { useReportHostTasksState } from 'View/report-host-tasks/state';
import Head from 'View/report-host-tasks/section/head';
import Filter from 'View/report-host-tasks/section/filter';
import Table from 'View/report-host-tasks/section/table';
import useGetReportHostTasks from 'Domain/report-host-tasks/useGetReportHostTasks';

import styles from './styles.module.css';

const ReportHostTasks = () => {
  const [enabled, setEnabled] = useState(false);
  const [searchParams] = useSearchParams();
  const { filterState, updateFilterState } = useReportHostTasksState();
  const { data, isFetching } = useGetReportHostTasks({ filter: filterState, enabled });
  const search = searchParams.get('search');
  const { t } = useTranslation('desktop-host-content');

  useEffect(() => {
    if (search) updateFilterState({ search });
    setEnabled(true);

    /* eslint-disable */
  }, [searchParams]);

  return (
    <Box className={styles['report-host-tasks__container']}>
      <Head t={t} />
      <Filter t={t} />
      <Table data={data} isFetching={isFetching} t={t} />
    </Box>
  );
};

const ReportHostTasksContainer = () => {
  return (
    <ReportHostTasksProvider>
      <ReportHostTasks />
    </ReportHostTasksProvider>
  );
};

export default ReportHostTasksContainer;
